export const VALIDATION_ERRORS = {
  MISSING_PERSONALIZE_EDIT_SCOPE: 'MISSING_PERSONALIZE_EDIT_SCOPE',
  MISSING_ASSET_WRITE_SCOPE: 'MISSING_ASSET_WRITE_SCOPE',
  MISSING_ASSET_AI_SCOPE: 'MISSING_ASSET_AI_SCOPE',
  GENERATIVE_AI_DISABLED: 'GENERATIVE_AI_DISABLED',
  NO_WRITE_SCOPE: 'NO_WRITE_SCOPE',
  STRATEGY_LIMIT_REACHED: 'STRATEGY_LIMIT_REACHED',
  STRATEGY_VARIANT_LIMIT_REACHED: 'STRATEGY_VARIANT_LIMIT_REACHED',
  ASSET_NOT_PERSONALIZABLE: 'ASSET_NOT_PERSONALIZABLE',
  UNSUPPORTED_ASSET_TYPE: 'UNSUPPORTED_ASSET_TYPE'
};
export const CONTENT_VALIDATION_ERRORS = {
  CANNOT_CREATE_VARIANT_OF_A_VARIANT: 'CANNOT_CREATE_VARIANT_OF_A_VARIANT',
  CANNOT_CREATE_VARIANT_FROM_AB_TEST: 'CANNOT_CREATE_VARIANT_FROM_AB_TEST',
  CANNOT_CREATE_VARIANT_FROM_LANGUAGE_VARIANT: 'CANNOT_CREATE_VARIANT_FROM_LANGUAGE_VARIANT',
  CANNOT_CREATE_VARIANT_FROM_LANGUAGE_MASTER: 'CANNOT_CREATE_VARIANT_FROM_LANGUAGE_MASTER',
  CANNOT_CREATE_VARIANT_OF_CONTENT_WITH_AUDIENCE_ACCESS: 'CANNOT_CREATE_VARIANT_OF_CONTENT_WITH_AUDIENCE_ACCESS',
  CANNOT_CREATE_VARIANT_WITH_SMART_CONTENT: 'CANNOT_CREATE_VARIANT_WITH_SMART_CONTENT',
  CANNOT_CREATE_VARIANT_OF_EMBEDDED_WEB_INTERACTIVE: 'CANNOT_CREATE_VARIANT_OF_EMBEDDED_WEB_INTERACTIVE',
  CANNOT_CREATE_VARIANT_OF_FEEDBACK_SURVEY_WEB_INTERACTIVE: 'CANNOT_CREATE_VARIANT_OF_FEEDBACK_SURVEY_WEB_INTERACTIVE'
};